import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';

import { Pagination } from '@shared/models';
import { BaseService } from '@shared/services/base.service';

import { GiftWithPurchaseTransactionReportCriteria } from '../../../shared/models/report.model';
import {
  CancelGiftWithPurchase,
  ChangeExpirationDateGiftWithPurchaseRequest,
  GiftWithPurchaseListContent,
  GiftWithPurchaseSearchCriteria,
  ViewGiftWithPurchase
} from '../model/gift-with-purchase.model';

@Injectable({
  providedIn: 'root'
})
export class GiftWithPurchaseService extends BaseService {
  public headers: HttpHeaders;
  envReportService;

  constructor(
    private readonly http: HttpClient,
    protected readonly logger: NGXLogger
  ) {
    super();
    this.envService = this.env.services.giftWithPurchase;
    this.envReportService = this.env.services.exportReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getGiftWithPurchaseList(criteria: GiftWithPurchaseSearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrl(this.envService.list);

    return this.http.get<Pagination<GiftWithPurchaseListContent>>(url, {
      headers: this.headers,
      observe: 'body',
      params
    });
  }

  getGiftWithPurchase(docNo: string) {
    const url = this.getFullUrl(this.envService.view, { docNo });
    return this.http.get<ViewGiftWithPurchase>(url, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  cancelGiftWithPurchase(data: CancelGiftWithPurchase) {
    const url = this.getFullUrl(this.envService.cancel, { docNo: data.docNo });
    return this.http.post(url, data, { headers: this.headers });
  }

  exportGiftWithPurchaseTransaction(criteria: GiftWithPurchaseTransactionReportCriteria) {
    const url = this.getFullUrl(this.envReportService.giftWithPurchaseTransaction, null, true);
    let headers = this.loaderHeaders();
    headers = headers.set('x-host', this.envReportService.headers['x-host']);
    return this.http.post<any>(url, criteria, {
      headers,
      observe: 'body'
    });
  }

  changeExpirationDate(data: ChangeExpirationDateGiftWithPurchaseRequest): Observable<any> {
    const url = this.getFullUrl(this.envService.changeExpiration);
    return this.http.put<any>(url, data, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  history(docNo: string): Observable<any> {
    const url = this.getFullUrl(this.envService.history, { docNo });
    return this.http.get<any>(url, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }
}
